/* eslint-disable */
import { RouteConfig } from 'vue-router';
import { Roles } from '@/modules/authentication/models/rolesEnum';
import Barcode from '@/modules/barcode/Barcode.vue';
import ReadBarcode from '@/modules/barcode/views/ReadBarcode.vue';

const rootPath = '/barcode';

const routes: Array<RouteConfig> = [
  {
    path: `${rootPath}`,
    name: 'Barcode',
    component: Barcode,
    redirect: { name: 'ReadBarcode' },
    meta: { requiredRole: Roles.requests_update_state },
    children: [
      {
        path: `${rootPath}/read`,
        name: 'ReadBarcode',
        component: ReadBarcode,
        meta: {
          title: 'barcode.ReadBarcode.metaTitle'
        }
      }
    ]
  }
];

export default routes;
